var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * 将一个元素变成只有一个元素的数组，如果该元素已经是数组则直接返回
 * @param arr
 * @example
 *
 * arrify(1) // => [1]
 * arrify([1]) // => [1]
 */
export function arrify(arr) {
    if (Array.isArray(arr))
        return arr;
    return [arr];
}
/**
 * 将一个嵌套数组扁平化一层,
 * @param arr
 * @example
 * flatten([[1], 2, 3]) // => [1, 2, 3]
 * flatten([1, [2], 3]) // => [1, 2, 3]
 * flatten([1, 2, 3]) // => [1, 2, 3]
 *
 */
export function flatten(arr) {
    var _a;
    return (_a = []).concat.apply(_a, arr);
}
/**
 * 将一个数组分组
 *
 * @param arr
 * @param fn
 * @example
 *
 * groupBy([1, 2, 3, 4], t => t % 2) // => {0: [2, 4], 1: [1, 3]}
 */
export function groupBy(arr, fn) {
    var group = {};
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        var k = fn(item, i, arr);
        var items = group[k] = group[k] || [];
        items.push(item);
    }
    return group;
}
/**
 * 将一个数组分成 n 个最大长度为 count 的数组
 *
 * @param arr
 * @param fn
 * @example
 * chunkBy([1, 2, 3, 4], t => 3) // => [[1,2,3],[4]]
 *
 */
export function chunkBy(arr, count) {
    if (arr.length <= count)
        return [arr];
    var newArr = [];
    for (var i = 0; i < arr.length; i++) {
        if (i % count === 0) {
            newArr.push([]);
        }
        newArr[newArr.length - 1].push(arr[i]);
    }
    return newArr;
}
export function uniqBy(arr, getKey) {
    if (getKey === void 0) { getKey = function (f) { return f; }; }
    var newArr = [];
    var keySet = new Set();
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        var key = getKey(item);
        if (!keySet.has(key)) {
            newArr.push(item);
            keySet.add(key);
        }
    }
    return newArr;
}
export function replaceItem(arr, finder, item) {
    var idx = arr.findIndex(finder);
    if (idx >= 0) {
        arr = __spreadArray([], arr, true);
        arr[idx] = item;
    }
    return arr;
}
//# sourceMappingURL=array.js.map